import { PopoverV2 } from '@opallabs/kuiper'

type PopoverTriggerEvents = 'click' | 'hover'

interface AssignmentPopoverProps {
  trigger: React.ReactNode
  triggerEvent: PopoverTriggerEvents
}

export const AssignmentPopover: React.FC<
  React.PropsWithChildren<AssignmentPopoverProps>
> = ({ trigger, triggerEvent, children }) => (
  <PopoverV2
    trigger={trigger}
    content={children}
    triggerEvent={triggerEvent}
    popoverHandlers={{ appendTo: () => document.body }}
  />
)
